import * as React from 'react'
import {
    getCiaFromUrl,
    HomeWidget, Link, menuHelper, PortalContext, withPagination
} from '@portal/arq-portal-core';

import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core';
import { obtenerDimensionesDetachedWindow } from './helpers'

const useStyles = makeStyles(() => ({
    soporteContainer: {
        marginTop: '0.75rem'
    },
    soporteListItem: {
        borderBottom: '1px solid #d6d8d8',
        '& .itemWrapper': {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '5px 0',
            cursor: 'pointer',
            '&  a': {
                height: '19px',
                width: '19px',


            },
            '&:hover': {
                color: '#919191',
            },
            '&:active': {
                color: '#dc0028',
            },
        },
    },

    titulo: {
        flex: 1,
        margin: '0 10px 0 0',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'

    },
    soporteList: {
        listStyle: 'none',
        padding: '0 0',
        margin: '0 0',

    },
    separadorFlex: {
        flex: '1 1 0'
    }
}));

interface Props {
    resultadosPorPagina: any[];
    verMas: string;
}

export const ListaSoporte = (props: Props): JSX.Element => {
    const { resultadosPorPagina, verMas } = props;
    const clases = useStyles(props);

    const abrirDetachedWindow = (enlace: string) => {
        let popup = window.open(enlace, 'soporte', obtenerDimensionesDetachedWindow());
        // evitar memory leaks
        popup?.addEventListener('pagehide', () => {
            if (!popup?.location?.host) return;
            // hacer el objeto disponible para ser garbage collected
            popup = null;
        });
    };

    if (resultadosPorPagina && resultadosPorPagina.length) {
        const listItems = resultadosPorPagina.map((item: any, index: number) => {
            return (
                <li className={clases.soporteListItem} key={index}>
                    {(item.url.startsWith("/")) ?
                        <Link className="itemWrapper" to={item.url}>
                            <Typography variant="caption" className={clases.titulo}>{item.titulo}</Typography>
                        </Link>
                        : <div className="itemWrapper" onClick={() => abrirDetachedWindow(item.url)}>
                            <Typography variant="caption" className={clases.titulo}>{item.titulo}</Typography>
                        </div>
                    }
                </li>)

        })

        return <HomeWidget titulo="Soporte" vermas={verMas}>
            {
                <div className={clases.soporteContainer}>
                    <ul className={clases.soporteList}>
                        {listItems}
                    </ul>

                </div>
            }
        </HomeWidget>


    } else {
        return <HomeWidget titulo="Soporte" vermas={verMas}>
            {
                <div className={clases.soporteContainer}>
                    <ul className={clases.soporteList}>

                    </ul>
                </div>
            }
        </HomeWidget>
    }


}

export const SoportePaginado = withPagination(ListaSoporte, 12);
export const Soporte = (props: any) => {

    var data: any = undefined;
    var error: any = undefined;
    var isLoading: boolean = false;

    const { menu } = React.useContext(PortalContext);

    if (props.data || props.error || props.isLoading) {
        data = props.data;
        error = props.error;
        isLoading = props.isLoading;
    } else {
        const cia = getCiaFromUrl();
        data = menuHelper.getMenuOption(menu, (cia == "AIE" || cia == "PRE")? "/Soporte" : "/Utilidades/Soporte")?.enlaces;
    }
    return <SoportePaginado data={data} error={error} isLoading={isLoading}></SoportePaginado>;
}
